import { SNSButton } from '~/constants';
import * as S from './SNSSignInButton.styled';

interface SNSSignInProps {
  title: SNSButton['title'];
  icon: SNSButton['icon'];
  onClick: () => void;
}

export default function SNSSignInButton({
  title,
  icon,
  onClick,
}: SNSSignInProps) {
  return (
    <S.Container>
      <S.SNSButton id={title} onClick={onClick}>
        <S.LogoBox>
          <img src={icon} alt={title} />
        </S.LogoBox>
        <strong>{`Continue with ${title}`}</strong>
      </S.SNSButton>
    </S.Container>
  );
}
